/**
 * Kamuni Product Modal - Refactorizado para ser completamente reutilizable
 * Maneja la funcionalidad del modal moderno para añadir productos al carrito
 */

// Funciones globales para uso en onclick (definidas antes de la clase)
function openKamuniModal(modalId) {
  // Buscar el modal en cualquier lugar del documento
  let modal = document.getElementById(`kamuni-modal-${modalId}`);

  if (modal) {
    // Asegurar que el modal esté en el body y tenga los estilos correctos
    ensureModalInBody(modal);
    window.kamuniModal?.openModal(modalId);
  } else {
    console.error(`Modal with ID kamuni-modal-${modalId} not found`);
  }
}

function ensureModalInBody(modal) {
  // Si el modal no está directamente en el body, moverlo
  if (modal.parentNode !== document.body) {
    // Clonar el modal para preservar todos los event listeners
    const clonedModal = modal.cloneNode(true);

    // Remover el original
    modal.remove();

    // Agregar el clonado al body
    document.body.appendChild(clonedModal);

    // Actualizar la referencia
    modal = clonedModal;
  }

  // Asegurar estilos críticos para que el modal se muestre correctamente
  modal.style.position = 'fixed';
  modal.style.top = '0';
  modal.style.left = '0';
  modal.style.width = '100%';
  modal.style.height = '100%';
  modal.style.zIndex = '99999';
}

function closeKamuniModal(modalId) {
  window.kamuniModal?.closeModal(modalId);
}

function updateKamuniQuantity(modalId, delta) {
  window.kamuniModal?.updateQuantity(modalId, delta);
}

function updateKamuniTotal(modalId) {
  window.kamuniModal?.updateTotal(modalId);
}

// Funciones globales para distribución de sabores
function updateFlavorQuantity(modalId, flavorIndex, delta) {
  const flavorInputs = document.querySelectorAll(`#flavors-list-${modalId} .kamuni-modal__flavor-input`);
  const input = flavorInputs[flavorIndex];

  if (!input) return;

  const currentValue = parseInt(input.value) || 0;
  const maxValue = parseInt(input.getAttribute('max')) || 50;
  const newValue = Math.max(0, Math.min(maxValue, currentValue + delta));

  input.value = newValue;
  window.kamuniModal?.validateFlavorDistribution(modalId);
}

function validateFlavorDistribution(modalId) {
  return window.kamuniModal?.validateFlavorDistribution(modalId);
}

class KamuniProductModal {
  constructor() {
    this.error = false; // Para mantener estado de error como en product-form.js
    this.initEventListeners();
    this.moveAllModalsToBody(); // Mover todos los modales al body al inicializar
  }

  moveAllModalsToBody() {
    // Buscar todos los modales y moverlos al body
    const modals = document.querySelectorAll('.kamuni-modal');
    modals.forEach((modal) => {
      if (modal.parentNode !== document.body) {
        modal.remove();
        document.body.appendChild(modal);
      }
    });
  }

  initEventListeners() {
    // Delegación de eventos para manejar múltiples modales
    document.addEventListener('change', this.handleVariantChange.bind(this));
    document.addEventListener('submit', this.handleFormSubmit.bind(this));
    document.addEventListener('input', this.handleQuantityInput.bind(this));

    // Cerrar modal con tecla Escape
    document.addEventListener('keydown', this.handleKeyDown.bind(this));

    // Cerrar modal al hacer clic en el backdrop
    document.addEventListener('click', this.handleBackdropClick.bind(this));

    // Observar cambios en el DOM para mover nuevos modales
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.classList?.contains('kamuni-modal')) {
            if (node.parentNode !== document.body) {
              node.remove();
              document.body.appendChild(node);
            }
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  handleVariantChange(event) {
    // Ya no se usan variantes, pero mantenemos el método por compatibilidad
    // La funcionalidad ahora se basa en productos individuales
  }

  handleQuantityInput(event) {
    if (event.target.matches('.kamuni-modal__quantity-input')) {
      const modalId = event.target.id.replace('quantity-', '');
      // Pequeño delay para asegurar que el valor se haya actualizado
      setTimeout(() => {
        this.updateTotal(modalId);
      }, 10);
    }
  }

  handleFormSubmit(event) {
    if (event.target.matches('.kamuni-modal__form')) {
      event.preventDefault();
      const modalId = event.target.dataset.modalId;
      this.addToCart(modalId);
    }
  }
  handleKeyDown(event) {
    if (event.key === 'Escape') {
      const openModal = document.querySelector('.kamuni-modal.kamuni-modal--visible');
      if (openModal) {
        const modalId = openModal.id.replace('kamuni-modal-', '');
        this.closeModal(modalId);
      }
    }
  }

  handleBackdropClick(event) {
    if (event.target.matches('.kamuni-modal__backdrop')) {
      const modal = event.target.closest('.kamuni-modal');
      if (modal) {
        const modalId = modal.id.replace('kamuni-modal-', '');
        this.closeModal(modalId);
      }
    }
  }
  openModal(modalId) {
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    if (!modal) return;

    // Mostrar modal y añadir clase de animación
    modal.style.display = 'flex';
    modal.style.position = 'fixed';
    modal.style.inset = '0';
    modal.style.zIndex = '9999'; // Z-index alto para estar encima de todo
    modal.setAttribute('aria-hidden', 'false');

    document.body.style.overflow = 'hidden';

    // Agregar clase de backdrop blur al body
    document.body.classList.add('kamuni-modal-open');

    // Forzar reflow antes de añadir clase visible
    modal.offsetHeight;

    // Añadir clase para animación de entrada
    setTimeout(() => {
      modal.classList.add('kamuni-modal--visible');
    }, 10);

    // Actualizar precios y configuración del producto al abrir
    this.updateProductInfo(modalId);

    // Asegurar que el total se muestre correctamente al abrir
    this.updateTotal(modalId);

    // Foco en el primer elemento interactivo después de la animación
    setTimeout(() => {
      const firstInput = modal.querySelector('input:not([type="hidden"]), button:not(.kamuni-modal__close)');
      if (firstInput) firstInput.focus();
    }, 350);
  }

  closeModal(modalId) {
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    if (!modal) return;

    // Remover clase visible para animación de salida
    modal.classList.remove('kamuni-modal--visible');
    modal.setAttribute('aria-hidden', 'true');

    // Esperar a que termine la animación antes de ocultar
    setTimeout(() => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      document.body.classList.remove('kamuni-modal-open');
    }, 300);

    // Resetear el formulario
    this.resetForm(modalId);
  }

  resetForm(modalId) {
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    if (!modal) return;

    const form = modal.querySelector('.kamuni-modal__form');
    const quantityInput = modal.querySelector(`#quantity-${modalId}`);

    if (quantityInput) quantityInput.value = '1';
    this.updateTotal(modalId);
    this.resetButtonState(modalId);
  }

  updateVariantAndPrice(modalId) {
    // Método deprecado - ahora usamos updateProductInfo
    this.updateProductInfo(modalId);
  }

  updateProductInfo(modalId) {
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    if (!modal) return;

    try {
      // Obtener información del producto desde los datos del modal
      const productData = JSON.parse(modal.dataset.variants || '[]');
      const productInfo = productData[0]; // Usar el primer (y único) producto

      if (productInfo) {
        this.updateProductDetails(modalId, productInfo);
      }
    } catch (error) {
      console.error('Error updating product info:', error);
    }
  }
  updateVariantInfo(modalId, variant) {
    // Método mantenido por compatibilidad - ahora delega a updateProductDetails
    this.updateProductDetails(modalId, variant);
  }

  updateProductDetails(modalId, productInfo) {
    // Actualizar input hidden de ID de producto/variante
    const variantIdInput = document.getElementById(`variant-id-${modalId}`);
    if (variantIdInput) {
      variantIdInput.value = productInfo.id;
    }

    // Actualizar precios en el modal
    const priceElement = document.getElementById(`modal-price-${modalId}`);
    const comparePriceElement = document.getElementById(`modal-compare-price-${modalId}`);
    const unitPriceDisplay = document.getElementById(`unit-price-display-${modalId}`);

    if (priceElement) {
      priceElement.textContent = this.formatMoney(productInfo.price);
    }

    // Obtener tamaño de caja desde el título del producto
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    const requiresDistribution = modal?.dataset?.requiresDistribution === 'true';
    
    let unidadesCaja = 1;
    // Buscar el tamaño de la caja desde el nombre del producto con patrones más amplios
    const productName = productInfo.name || productInfo.title || 'Producto sin nombre';
    const boxSizeMatch = productName.match(/(?:caja|box|pack)?\s*(?:de\s*|x|×)?\s*(\d+)|(\d+)\s*(?:unidades?|piezas?|uds?|units?)/i);
    if (boxSizeMatch) {
      unidadesCaja = parseInt(boxSizeMatch[1] || boxSizeMatch[2]);
  
    } else {
      // Si no se encuentra en el nombre, buscar solo números grandes (probablemente el tamaño)
      const numberMatch = productName.match(/\b(\d{2,3})\b/);
      if (numberMatch) {
        unidadesCaja = parseInt(numberMatch[1]);
      } else {
        unidadesCaja = 25;
      }
    }

    // Solo mostrar y actualizar precio unitario si el producto requiere distribución
    if (unitPriceDisplay && requiresDistribution) {
      // Mostrar el precio unitario por unidad de caja
      const unitPrice = unidadesCaja > 1 ? Math.round(productInfo.price / unidadesCaja) : productInfo.price;
      unitPriceDisplay.textContent = this.formatMoney(unitPrice);
    }

    if (comparePriceElement) {
      if (productInfo.compare_at_price && productInfo.compare_at_price > productInfo.price) {
        comparePriceElement.textContent = this.formatMoney(productInfo.compare_at_price);
        comparePriceElement.style.display = '';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }

    // Actualizar disponibilidad del botón
    const addButton = document.getElementById(`add-btn-${modalId}`);
    const buttonText = addButton?.querySelector('.kamuni-modal__btn-text');

    if (addButton && buttonText) {
      if (productInfo.available) {
        addButton.disabled = false;
        buttonText.textContent = 'Añadir al carrito';
      } else {
        addButton.disabled = true;
        buttonText.textContent = 'Agotado';
      }
    }

    // Verificar si este producto requiere distribución de sabores y actualizar la UI
    this.updateFlavorDistribution(modalId, productInfo);

    // Actualizar total con el nuevo precio del producto
    this.updateTotal(modalId);
  }

  updateQuantity(modalId, delta) {
    const quantityInput = document.getElementById(`quantity-${modalId}`);
    if (!quantityInput) return;

    const currentValue = parseInt(quantityInput.value) || 1;
    const newValue = Math.max(1, currentValue + delta);

    quantityInput.value = newValue;
    this.updateTotal(modalId);
  }
  updateTotal(modalId) {
    const quantityInput = document.getElementById(`quantity-${modalId}`);
    const totalElement = document.getElementById(`total-price-${modalId}`);
    const variantIdInput = document.getElementById(`variant-id-${modalId}`);
    const modal = document.getElementById(`kamuni-modal-${modalId}`);

    if (!quantityInput || !totalElement || !modal) {
      return;
    }

    // Verificar si está activa la distribución de sabores
    const flavorSection = document.getElementById(`flavors-section-${modalId}`);
    const isFlavorDistribution = flavorSection && flavorSection.classList.contains('kamuni-modal__flavors--visible');

    // Si hay distribución de sabores, la cantidad siempre es 1 (una caja)
    const quantity = isFlavorDistribution ? 1 : parseInt(quantityInput.value) || 1;

    try {
      const productData = JSON.parse(modal.dataset.variants || '[]');
      const currentProduct = productData[0]; // Ahora solo hay un producto por modal

      if (currentProduct) {
        const totalPrice = currentProduct.price * quantity;
        totalElement.textContent = this.formatMoney(totalPrice);
      } else {
        // Fallback: usar el precio del modal de información del producto
        this.updateTotalFromPriceDisplay(modalId, quantity);
      }
    } catch (error) {
      console.error('Error updating total:', error);
      // Fallback: usar el precio del modal de información del producto
      this.updateTotalFromPriceDisplay(modalId, quantity);
    }
  }

  updateTotalFromPriceDisplay(modalId, quantity) {
    // Método fallback para calcular el total desde el precio mostrado
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    const requiresDistribution = modal?.dataset?.requiresDistribution === 'true';
    
    const unitPriceDisplay = requiresDistribution 
      ? document.getElementById(`unit-price-display-${modalId}`)
      : document.getElementById(`modal-price-${modalId}`);
    const totalElement = document.getElementById(`total-price-${modalId}`);

    if (unitPriceDisplay && totalElement) {
      const unitPriceInCents = this.parseMoney(unitPriceDisplay.textContent);
      const totalPriceInCents = unitPriceInCents * quantity;
      totalElement.textContent = this.formatMoney(totalPriceInCents);
    }
  }
  async addToCart(modalId) {
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    const form = modal?.querySelector('.kamuni-modal__form');

    if (!form) return;

    // Verificar que tenemos acceso a las funciones globales necesarias
    if (typeof fetchConfig !== 'function') {
      console.error('fetchConfig no está disponible');
      this.showErrorNotification('Error de configuración. Recarga la página e inténtalo de nuevo.');
      return;
    }

    if (typeof routes === 'undefined' || !routes.cart_add_url) {
      console.error('routes.cart_add_url no está disponible');
      this.showErrorNotification('Error de configuración. Recarga la página e inténtalo de nuevo.');
      return;
    }

    this.setLoadingState(modalId, true);

    // Validar distribución de sabores si es necesaria
    const flavorSection = document.getElementById(`flavors-section-${modalId}`);
    if (flavorSection && flavorSection.classList.contains('kamuni-modal__flavors--visible')) {
      const isValidDistribution = this.validateFlavorDistribution(modalId);
      if (!isValidDistribution) {
        this.setLoadingState(modalId, false);
        this.showErrorNotification('Por favor completa la distribución de sabores correctamente.');
        return;
      }
    }

    try {
      // Detectar si estamos en la página del carrito principal
      const isCartPage = window.location.pathname.includes('/cart') || document.querySelector('cart-items');
      
      // Usar el mismo flujo que product-form.js
      const formData = new FormData(form);

      // Asegurar que tenemos cantidad (por defecto 1)
      if (!formData.get('quantity')) {
        formData.set('quantity', '1');
      }

      // Para página del carrito, forzar el uso de cart-items incluso si existe cart-notification
      let cart;
      if (isCartPage) {
        cart = document.querySelector('cart-items');
      } else {
        cart = document.querySelector('cart-notification') || 
              document.querySelector('cart-drawer') || 
              document.querySelector('cart-items');
      }

      let sectionsToRender = [];
      
      if (cart && cart.getSectionsToRender && !isCartPage) {
        // Para cart-notification y cart-drawer (pero no en página de carrito)
        sectionsToRender = cart.getSectionsToRender().map((section) => section.section || section.id);
        cart.setActiveElement(document.activeElement);
      } else if (isCartPage || document.querySelector('cart-items')) {
        // Para página de carrito principal, usar los mismos IDs que cart.js
        sectionsToRender = [
          'cart-icon-bubble',
          'cart-live-region-text'
        ];
        
        // Obtener el data-id de las secciones principales del carrito
        const mainCartItems = document.getElementById('main-cart-items');
        const mainCartFooter = document.getElementById('main-cart-footer');
        
        if (mainCartItems && mainCartItems.dataset.id) {
          sectionsToRender.push(mainCartItems.dataset.id);
        }
        if (mainCartFooter && mainCartFooter.dataset.id) {
          sectionsToRender.push(mainCartFooter.dataset.id);
        }
      } else {
        // Fallback: al menos actualizar el ícono del carrito
        sectionsToRender = ['cart-icon-bubble'];
      }

      if (sectionsToRender.length > 0) {
        formData.append('sections', sectionsToRender.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      // Configurar request igual que en product-form.js
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);

      // Verificar que la respuesta sea válida
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Intentar parsear como JSON directamente
      const data = await response.json();

      if (data.status) {
        // Manejar errores igual que en product-form.js
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'kamuni-modal',
            productVariantId: formData.get('id'),
            errors: data.errors || data.description,
            message: data.message,
          });
        }

        this.error = true;
        this.showErrorNotification(data.description || 'Error al añadir el producto al carrito');
        return;
      }

      // Éxito: Usar el mismo flujo que product-form.js
      this.error = false;
      if (!this.error) {
        // Publicar evento de actualización del carrito
        const startMarker = window.CartPerformance?.createStartingMarker('kamuni-add:wait-for-subscribers');

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'kamuni-modal',
            productVariantId: formData.get('id'),
            cartData: data,
            variantId: formData.get('id')
          });
        }

        if (startMarker && window.CartPerformance) {
          window.CartPerformance.measureFromMarker('kamuni-add:wait-for-subscribers', startMarker);
        }

        // Renderizar contenido del carrito
        if (cart && cart.renderContents && !isCartPage) {
          // Para cart-notification y cart-drawer (no en página de carrito)
          if (window.CartPerformance) {
            window.CartPerformance.measure('kamuni-add:paint-updated-sections', () => {
              cart.renderContents(data);
            });
          } else {
            cart.renderContents(data);
          }
        } else if (data.sections) {
          // Para página de carrito principal, actualizar secciones manualmente
          this.updateCartSections(data.sections);
          
          // Forzar actualización del estado del carrito en cart-items
          const cartItemsElement = document.querySelector('cart-items');
          if (cartItemsElement && cartItemsElement.onCartUpdate) {
            // Llamar directamente al método onCartUpdate si existe
            cartItemsElement.onCartUpdate();
          }
        }

        // Actualizar el estado global del carrito si la respuesta incluye datos del carrito
        if (data.item_count !== undefined) {
          // Actualizar clases de estado vacío en elementos principales
          const cartItemsElement = document.querySelector('cart-items');
          const cartFooterElement = document.getElementById('main-cart-footer');
          const cartDrawerElement = document.querySelector('cart-drawer');
          
          const isEmpty = data.item_count === 0;
          
          if (cartItemsElement) cartItemsElement.classList.toggle('is-empty', isEmpty);
          if (cartFooterElement) cartFooterElement.classList.toggle('is-empty', isEmpty);
          if (cartDrawerElement) cartDrawerElement.classList.toggle('is-empty', isEmpty);
        }
      }

      // Cerrar modal después del éxito (con un pequeño delay para que se vea la notificación)
      setTimeout(() => {
        this.closeModal(modalId);
      }, 500);
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showErrorNotification('Error al añadir el producto al carrito. Inténtalo de nuevo.');
    } finally {
      this.setLoadingState(modalId, false);

      // Performance tracking igual que en product-form.js
      if (window.CartPerformance) {
        try {
          // Crear un evento simulado para el tracking
          const simulatedEvent = new Event('kamuni-modal-submit');
          window.CartPerformance.measureFromEvent('kamuni-add:user-action', simulatedEvent);
        } catch (e) {
          // Si falla el performance tracking, no es crítico
        }
      }
    }
  }

  setLoadingState(modalId, loading) {
    const button = document.getElementById(`add-btn-${modalId}`);
    const buttonText = button?.querySelector('.kamuni-modal__btn-text');
    const buttonIcon = button?.querySelector('.kamuni-modal__btn-icon');
    const buttonLoading = button?.querySelector('.kamuni-modal__btn-loading');

    if (!button || !buttonText || !buttonIcon || !buttonLoading) return;

    if (loading) {
      button.disabled = true;
      buttonText.style.display = 'none';
      buttonIcon.style.display = 'none';
      buttonLoading.style.display = 'block';
    } else {
      button.disabled = false;
      buttonText.style.display = 'block';
      buttonIcon.style.display = 'block';
      buttonLoading.style.display = 'none';
    }
  }

  resetButtonState(modalId) {
    this.setLoadingState(modalId, false);
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Actualizar elementos de contador del carrito
      const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
      cartCountElements.forEach((element) => {
        element.textContent = cart.item_count;
      });

      // Actualizar bubble del carrito
      const cartBubble = document.getElementById('cart-icon-bubble');
      if (cartBubble) {
        const bubble = cartBubble.querySelector('.cart-count-bubble');
        if (bubble) {
          bubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  showSuccessNotification(message) {
    this.showNotification(message, 'success');
  }

  showErrorNotification(message) {
    this.showNotification(message, 'error');
  }

  showNotification(message, type = 'info') {
    // Crear notificación temporal
    const notification = document.createElement('div');
    notification.className = `kamuni-notification kamuni-notification--${type}`;
    notification.textContent = message;

    // Estilos inline para la notificación
    Object.assign(notification.style, {
      position: 'fixed',
      top: '2rem',
      right: '2rem',
      background: type === 'success' ? '#00928b' : '#e53b58',
      color: 'white',
      padding: '1rem 1.5rem',
      borderRadius: '0.75rem',
      fontWeight: '600',
      zIndex: '100',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
      transform: 'translateX(100%)',
      transition: 'transform 0.3s ease',
    });

    document.body.appendChild(notification);

    // Animar entrada
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);

    // Remover después de 3 segundos
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }
  formatMoney(cents) {
    // Formatear dinero según la configuración de Shopify para Colombia
    // En Shopify, los precios se almacenan en centavos, pero COP normalmente no usa centavos
    const amount = cents / 100;

    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }
  parseMoney(moneyString) {
    // Extraer número del string de dinero formateado (COP)
    if (!moneyString || typeof moneyString !== 'string') {
      return 0;
    }

    // Remover símbolos de moneda, espacios, puntos separadores de miles y comas
    const numericString = moneyString
      .replace(/[COP\$\s]/g, '') // Remover COP, $, espacios
      .replace(/\./g, '') // Remover puntos separadores de miles
      .replace(/,/g, ''); // Remover comas si las hay

    const amount = parseInt(numericString) || 0;

    // Si el string original tenía formato de centavos (ej: "12.99"),
    // pero COP normalmente no usa centavos, asumir que es el valor completo
    // Convertir a centavos para mantener consistencia con Shopify
    return amount * 100;
  }

  // Funciones para distribución de sabores
  updateFlavorDistribution(modalId, productInfo) {
    const flavorSection = document.getElementById(`flavors-section-${modalId}`);
    const quantitySection = document.querySelector(`#kamuni-modal-${modalId} .kamuni-modal__quantity`);
    const modal = document.getElementById(`kamuni-modal-${modalId}`);

    if (!flavorSection || !modal) return;

    // Verificar si el producto requiere distribución según el metafield
    const requiresDistribution = modal.dataset.requiresDistribution === 'true';

    // Buscar en el nombre del producto números que indiquen cantidad para el tamaño de caja
    const productName = productInfo.name || productInfo.title || 'Producto sin nombre';
    const boxSizeMatch = productName.match(/(?:caja|box|pack)?\s*(?:de\s*|x|×)?\s*(\d+)|(\d+)\s*(?:unidades?|piezas?|uds?|units?)/i);
    let boxSize = 25; // default
    
    if (boxSizeMatch) {
      boxSize = parseInt(boxSizeMatch[1] || boxSizeMatch[2]);
    } else {
      // Si no se encuentra en el nombre, buscar solo números grandes (probablemente el tamaño)
      const numberMatch = productName.match(/\b(\d{2,3})\b/);
      if (numberMatch) {
        boxSize = parseInt(numberMatch[1]);
      }
    }

    if (requiresDistribution) {
      // Mostrar sección de sabores y ocultar cantidad general
      flavorSection.classList.add('kamuni-modal__flavors--visible');
      this.setupFlavorDistribution(modalId, boxSize);
    } else {
      // Ocultar sección de sabores y mostrar cantidad general
      flavorSection.classList.remove('kamuni-modal__flavors--visible');
      if (quantitySection) {
        quantitySection.classList.remove('kamuni-modal__quantity--hidden');
      }
    }
  }

  setupFlavorDistribution(modalId, boxSize) {
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    const productType = modal?.dataset?.productType || 'barquillos';
    
    // Lista de sabores según el tipo de producto
    let availableFlavors = [];
    
    if (productType === 'alfajores') {
      availableFlavors = [
        { name: 'Chocolate Blanco', colorClass: 'chocolate-blanco' },
        { name: 'Chocolate Negro', colorClass: 'chocolate-negro' }
      ];
    } else {
      // Sabores para barquillos (default)
      availableFlavors = [
        { name: 'Tradicional', colorClass: 'tradicional' },
        { name: 'Capuccino', colorClass: 'capuccino' },
        { name: 'Mocca', colorClass: 'mocca' },
        { name: 'Avellana', colorClass: 'avellana' },
        { name: 'Whisky', colorClass: 'whisky' },
        { name: 'Cookies & Cream', colorClass: 'cookies-cream' },
      ];
    }

    // Actualizar elementos con el tamaño de la caja
    const boxSizeElement = document.getElementById(`box-size-${modalId}`);
    const requiredElement = document.getElementById(`flavors-required-${modalId}`);

    if (boxSizeElement) boxSizeElement.textContent = boxSize;
    if (requiredElement) requiredElement.textContent = boxSize;

    // Ocultar el input de cantidad general
    const quantitySection = document.querySelector(`#kamuni-modal-${modalId} .kamuni-modal__quantity`);
    if (quantitySection) {
      quantitySection.classList.add('kamuni-modal__quantity--hidden');
    }

    // Generar lista de sabores
    const flavorsList = document.getElementById(`flavors-list-${modalId}`);
    if (!flavorsList) return;

    flavorsList.innerHTML = '';

    availableFlavors.forEach((flavor, index) => {
      const flavorItem = document.createElement('div');
      flavorItem.className = 'kamuni-modal__flavor-item';
      flavorItem.innerHTML = `
        <span class="kamuni-modal__flavor-name">
          <span class="kamuni-modal__flavor-color kamuni-modal__flavor-color--${flavor.colorClass}"></span>
          ${flavor.name}
        </span>
        <div class="kamuni-modal__flavor-controls">
          <button type="button" class="kamuni-modal__flavor-btn" onclick="updateFlavorQuantity('${modalId}', ${index}, -1)">
            <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"/>
            </svg>
          </button>
          <input 
            type="number" 
            class="kamuni-modal__flavor-input" 
            value="0" 
            min="0" 
            max="${boxSize}"
            data-flavor="${flavor.name}"
            data-index="${index}"
            onchange="validateFlavorDistribution('${modalId}')"
          >
          <button type="button" class="kamuni-modal__flavor-btn" onclick="updateFlavorQuantity('${modalId}', ${index}, 1)">
            <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
          </button>
        </div>
      `;
      flavorsList.appendChild(flavorItem);
    });

    // Inicializar distribución automática simple
    this.autoDistributeFlavors(modalId, boxSize, availableFlavors.length);
  }

  autoDistributeFlavors(modalId, boxSize, flavorCount) {
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    const productType = modal?.dataset?.productType || 'barquillos';
    const flavorInputs = document.querySelectorAll(`#flavors-list-${modalId} .kamuni-modal__flavor-input`);

    if (productType === 'alfajores' && flavorCount === 2) {
      // Para alfajores con 2 sabores, hacer distribución 50/50 o lo más cercano posible
      const halfAmount = Math.floor(boxSize / 2);
      const remainder = boxSize % 2;
      flavorInputs.forEach((input, index) => {
        if (index === 0) {
          input.value = halfAmount + remainder; // El primer sabor lleva el extra si es impar
        } else {
          input.value = halfAmount;
        }
      });
    } else if (productType === 'barquillos' && flavorInputs.length === 6) {
      // Distribución personalizada para marquillos/barquillos
      let distribucion = [];
      if (boxSize === 50) {
        distribucion = [10, 8, 8, 8, 8, 8];
      } else if (boxSize === 25) {
        distribucion = [5, 4, 4, 4, 4, 4];
      } else {
        // Si no es 25 ni 50, usar distribución equitativa
        const baseAmount = Math.floor(boxSize / flavorCount);
        const remainder = boxSize % flavorCount;
        distribucion = Array(flavorCount).fill(baseAmount);
        for (let i = 0; i < remainder; i++) {
          distribucion[i] += 1;
        }
      }

      // Si la suma supera el boxSize, reducir los extras proporcionalmente
      let suma = distribucion.reduce((a, b) => a + b, 0);
      if (suma > boxSize) {
        let exceso = suma - boxSize;
        // Reducir de los sabores que no son Tradicional (index > 0)
        for (let i = 1; i < distribucion.length && exceso > 0; i++) {
          let quitar = Math.min(exceso, distribucion[i] - 1); // No dejar en 0
          distribucion[i] -= quitar;
          exceso -= quitar;
        }
        // Si aún hay exceso, reducir Tradicional
        if (exceso > 0) {
          distribucion[0] = Math.max(1, distribucion[0] - exceso);
        }
      }

      // Asignar valores
      flavorInputs.forEach((input, index) => {
        input.value = distribucion[index];
      });
    } else {
      // Distribución original para otros productos
      const baseAmount = Math.floor(boxSize / flavorCount);
      const remainder = boxSize % flavorCount;
      flavorInputs.forEach((input, index) => {
        const amount = baseAmount + (index < remainder ? 1 : 0);
        input.value = amount;
      });
    }

    this.validateFlavorDistribution(modalId);
  }

  validateFlavorDistribution(modalId) {
    const flavorInputs = document.querySelectorAll(`#flavors-list-${modalId} .kamuni-modal__flavor-input`);
    const totalElement = document.getElementById(`flavors-total-${modalId}`);
    const requiredElement = document.getElementById(`flavors-required-${modalId}`);
    const summaryElement = document.getElementById(`flavors-summary-${modalId}`);
    const addButton = document.getElementById(`add-btn-${modalId}`);

    if (!totalElement || !requiredElement || !summaryElement) return;

    let total = 0;
    flavorInputs.forEach((input) => {
      total += parseInt(input.value) || 0;
    });

    const required = parseInt(requiredElement.textContent);
    totalElement.textContent = total;

    // Actualizar estado visual
    summaryElement.classList.remove('kamuni-modal__flavors-summary--error', 'kamuni-modal__flavors-summary--success');

    if (total === required) {
      summaryElement.classList.add('kamuni-modal__flavors-summary--success');
      if (addButton) addButton.disabled = false;
    } else {
      summaryElement.classList.add('kamuni-modal__flavors-summary--error');
      if (addButton) addButton.disabled = true;
    }

    // Generar campos ocultos para el formulario
    this.generateFlavorInputs(modalId);

    return total === required;
  }

  generateFlavorInputs(modalId) {
    const flavorInputs = document.querySelectorAll(`#flavors-list-${modalId} .kamuni-modal__flavor-input`);
    const hiddenInputsContainer = document.getElementById(`flavor-inputs-${modalId}`);
    const modal = document.getElementById(`kamuni-modal-${modalId}`);
    const productType = modal?.dataset?.productType || 'barquillos';

    if (!hiddenInputsContainer) return;

    // Limpiar inputs anteriores
    hiddenInputsContainer.innerHTML = '';

    // Generar datos de sabores para enviar al carrito
    const flavorData = [];

    flavorInputs.forEach((input) => {
      const quantity = parseInt(input.value) || 0;
      if (quantity > 0) {
        const flavor = input.getAttribute('data-flavor');
        flavorData.push(`${flavor}: ${quantity}`);
      }
    });

    // Crear input hidden con la distribución de sabores
    if (flavorData.length > 0) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      
      // Usar nombres de propiedades específicos según el tipo de producto
      if (productType === 'alfajores') {
        hiddenInput.name = 'properties[Distribución de Alfajores]';
      } else {
        hiddenInput.name = 'properties[Distribución de Sabores]';
      }
      
      hiddenInput.value = flavorData.join(', ');
      hiddenInputsContainer.appendChild(hiddenInput);

      // La cantidad siempre es 1 (una caja), no la suma de sabores
      const quantityInput = document.getElementById(`quantity-${modalId}`);
      if (quantityInput) {
        quantityInput.value = '1';
      }
    }
  }

  // Función para sincronizar con el producto seleccionado en la página principal
  syncWithMainPageSelection(modalId) {
    // Ya no necesitamos sincronización con variantes
    // El producto individual ya está definido en el modal
  }

  // Función auxiliar mantenida por compatibilidad
  updateModalSelectsFromVariant(modalId, variant) {
    // Ya no hay selects de variantes que actualizar
  }

  // Método para actualizar las secciones del carrito manualmente
  updateCartSections(sections) {
   
    
    // Usar la misma lógica que CartItems.getSectionsToRender() en cart.js
    const sectionsMap = [
      {
        id: 'main-cart-items',
        element: document.getElementById('main-cart-items'),
        selector: '.js-contents',
        sectionKey: document.getElementById('main-cart-items')?.dataset?.id
      },
      {
        id: 'cart-icon-bubble',
        element: document.getElementById('cart-icon-bubble'),
        selector: '.shopify-section',
        sectionKey: 'cart-icon-bubble'
      },
      {
        id: 'cart-live-region-text',
        element: document.getElementById('cart-live-region-text'),
        selector: '.shopify-section',
        sectionKey: 'cart-live-region-text'
      },
      {
        id: 'main-cart-footer',
        element: document.getElementById('main-cart-footer'),
        selector: '.js-contents',
        sectionKey: document.getElementById('main-cart-footer')?.dataset?.id
      }
    ];

    // Actualizar cada sección disponible
    sectionsMap.forEach(sectionConfig => {
      const { id, element, selector, sectionKey } = sectionConfig;
      
      if (element && sectionKey && sections[sectionKey]) {
        try {
          const parser = new DOMParser();
          const html = parser.parseFromString(sections[sectionKey], 'text/html');
          
          // Buscar el contenido a reemplazar
          const elementToReplace = element.querySelector(selector) || element;
          const newContent = html.querySelector(selector);
          
          if (newContent && elementToReplace) {
            elementToReplace.innerHTML = newContent.innerHTML;
          }
        } catch (error) {
          // Error silenciado en producción
        }
      } else if (sections[id]) {
        // Fallback para secciones simples
        try {
          if (element) {
            element.innerHTML = sections[id];
          }
        } catch (error) {
          // Error silenciado en producción
        }
      }
    });

    // Actualizar el estado del carrito vacío/lleno
    const cartItemsElement = document.querySelector('cart-items');
    if (cartItemsElement && typeof window.cart !== 'undefined' && window.cart.item_count !== undefined) {
      const isEmpty = window.cart.item_count === 0;
      cartItemsElement.classList.toggle('is-empty', isEmpty);
      
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) {
        cartFooter.classList.toggle('is-empty', isEmpty);
      }
    }
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.kamuniModal = new KamuniProductModal();
  });
} else {
  window.kamuniModal = new KamuniProductModal();
}
